import { render, staticRenderFns } from "./ModalDeletePublishRequest.vue?vue&type=template&id=6b34ad4e"
import script from "./ModalDeletePublishRequest.vue?vue&type=script&lang=js"
export * from "./ModalDeletePublishRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports